import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Footer from "./Footer";
import "../styles/NotFound.scss";
import { isMobile } from "react-device-detect";
import { useAuth } from "react-oidc-context";
import IdleUserHeader from "./IdleUserHeader";

type Props = {};

const IdleUserMessage = (props: Props) => {
  const auth = useAuth();

  return (
    <>
      <IdleUserHeader />
      <div className="not-found-background-container">
        <div
          className={
            isMobile
              ? "d-flex flex-column not-found-container-mobile"
              : "d-flex flex-row justify-content-center not-found-container-desktop align-items-baseline"
          }
        >
          <div className="image-container">
            <img src="/icons/404_icon.svg" />
          </div>
          <div className="text-container">
            <div className="text-not-found-title">Session timed out</div>
            <div className="text-not-found-content">
              Your session has timed out due to inactivity. Please login again
              to continue
            </div>
            <Button
              className="text-not-button-go-home"
              onClick={() => {
                auth.signinRedirect({
                  prompt: "login",
                  extraQueryParams: {
                    action: "asha_login",
                  },
                });
              }}
            >
              Go to Login
            </Button>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default IdleUserMessage;
